// extracted by mini-css-extract-plugin
export default {"KeyGiversList":"KeyGiversList_KeyGiversList__HbptA","locationId":"KeyGiversList_locationId__5P9SO","respawnTime":"KeyGiversList_respawnTime__W7reQ"};